/** Firestore `users/{uid}.onboardingStatus` — analytics-friendly lifecycle */

export const ONBOARDING_STATUS_NEEDS_PROFILE = "needs_profile";
export const ONBOARDING_STATUS_PROFILE_COMPLETE = "profile_complete";

/** Legacy value written before staged onboarding; treat like needs_profile */
export const ONBOARDING_STATUS_LEGACY_INCOMPLETE = "incomplete";

/**
 * Profile is "complete" for segments when the user has saved a first name
 * (the name step / Create Account — same bar for email, Google, and phone-first).
 */
export function userDocProfileComplete(userDocData) {
  if (!userDocData || typeof userDocData !== "object") return false;
  const fn = userDocData.firstName;
  return typeof fn === "string" && fn.trim().length > 0;
}

/**
 * Effective onboarding status from Firestore fields (firstName wins; honors
 * stored profile_complete; maps legacy incomplete → needs_profile).
 */
export function resolveOnboardingStatusFromUserDoc(userDocData) {
  if (!userDocData || typeof userDocData !== "object") {
    return ONBOARDING_STATUS_NEEDS_PROFILE;
  }
  if (userDocProfileComplete(userDocData)) {
    return ONBOARDING_STATUS_PROFILE_COMPLETE;
  }
  const raw = userDocData.onboardingStatus;
  if (raw === ONBOARDING_STATUS_PROFILE_COMPLETE) {
    return ONBOARDING_STATUS_PROFILE_COMPLETE;
  }
  if (
    raw === ONBOARDING_STATUS_NEEDS_PROFILE ||
    raw === ONBOARDING_STATUS_LEGACY_INCOMPLETE
  ) {
    return ONBOARDING_STATUS_NEEDS_PROFILE;
  }
  return ONBOARDING_STATUS_NEEDS_PROFILE;
}

/** True when the user still owes the name step (or equivalent profile fields). */
export function userNeedsProfileCompletion(userDocData) {
  return (
    resolveOnboardingStatusFromUserDoc(userDocData) ===
    ONBOARDING_STATUS_NEEDS_PROFILE
  );
}

/** Phone verified but profile incomplete — resume at the name step. */
export function userNeedsNameAfterPhoneVerify(userDocData, phoneVerified) {
  return userNeedsProfileCompletion(userDocData) && phoneVerified === true;
}
